import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static identifier = "department-switcher"

  switch(event) {
    const select = event?.target
    const option = select?.selectedOptions?.[0]

    if (!option) {
      return
    }

    const url = option.dataset.url
    const method = (option.dataset.method || "post").toLowerCase()
    const turboPref = option.dataset.turbo

    if (!url) {
      return
    }

    const form = document.createElement("form")
    form.action = url
    form.method = method === "get" ? "get" : "post"
    form.style.display = "none"
    form.dataset.turbo = turboPref ?? "false"

    if (form.method === "post") {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      if (token) {
        const tokenInput = document.createElement("input")
        tokenInput.type = "hidden"
        tokenInput.name = "authenticity_token"
        tokenInput.value = token
        form.appendChild(tokenInput)
      }
    }

    document.body.appendChild(form)
    form.submit()
  }
}
